const admin_user = {
  userid: "",
  password: "",
  logged_in: false,
};

const AdminUserReducer = (state = admin_user, action) => {
  if (action.type === "SET_ADMIN_USER_IN") {
    return { ...action, logged_in: true, ...action };
  } else if (action.type === "SET_ADMIN_USER_OUT") {
    return { logged_in: false };
  }
  return state;
};
export default AdminUserReducer;
